import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiwrapperService } from 'src/app/services/apiwrapper.service';

@Injectable({
  providedIn: 'root'
})
export class CustomPollOnboardingService {
  public currentCustomPoll: any;

  constructor(private api: ApiwrapperService) { }

  getChekinsCategories(customPollUuid: string): Observable<any> {
    return this.api.getCustomPollTimedQuestions(customPollUuid);
  }

  getChekinsCategoriesStatements(collectionUuid: string): Observable<any> {
    return this.api.getCustomPollTimedQuestionsStatements(collectionUuid, true);
  }

  getChekinsSelectedCategories(customPollUuid: string): Observable<any> {
    return this.api.getChekinsSelectedCategories(customPollUuid);
  }
}
